export default __webpack_public_path__ + "static/media/chip1000000.c438cd16.png";